import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Transactions from './LoanPaymentAba/Transactions';
import History from './LoanPaymentAba/History';
import List from './List';

export default function router(): JSX.Element {
    return (
        <Switch>
            <Route exact={true} path='/loans/payment-abas' component={List} />
            <Route exact={true} path='/loans/payment-abas/:loanPaymentAbaUuid/transactions' component={Transactions} />
            <Route exact={true} path='/loans/payment-abas/:loanPaymentAbaUuid/history' component={History} />
        </Switch>
    );
}
